import React, { PureComponent } from "react"
import PropTypes from "prop-types"
import MultiSelector from "./MultiSelector"
import "./PersonnelMultiSelector.css"
import Checkbox from "../Checkbox/Checkbox"

class PersonnelMultiSelector extends PureComponent {
  renderOptions = () => {
    const { handleChange, options, filters } = this.props
    if (options) {
      return options.map(o => (
        <li key={o.value.minPersonnel}>
          <Checkbox
            label={o.label}
            id={o.label}
            onClick={() => handleChange(o, "personnel")}
            checked={filters.some(f => f.value.maxPersonnel === o.value.maxPersonnel)}
          />
        </li>
      ))
    }
    return null
  }

  render() {
    const { handleChange, options, filters, ...rest } = this.props
    return (
      <div className="personnel-selector-wrapper">
        <MultiSelector
          text="Henkilöstö"
          filters={filters}
          filter="personnel"
          options={options}
          target="personnel"
          handleChange={handleChange}
          {...rest}
        >
          <ul>
            {this.renderOptions()}
          </ul>
          <p className="personnel-source-info">
            Lähde: Profinder tilinpäätöstiedot ja Tilastokeskus kuntakohtaiset henkilöstötiedot (sis. palkansaajien ja yrittäjien henkilötyövuodet)
          </p>
        </MultiSelector>
      </div>
    )
  }
}

PersonnelMultiSelector.propTypes = {
  toggleSelector: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  clearFilters: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape()),
}

export default PersonnelMultiSelector
